<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterSearch :fetchData="fetchCitiesPaginated" />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('filters.country')"
        :fetchData="fetchCitiesPaginated"
        :items="countries"
        type="countryCode"
        itemText="text"
        value="value"
      />
    </v-col>
    <v-col v-if="selectedCountry" cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('filters.state')"
        :fetchData="fetchCitiesPaginated"
        :items="states"
        type="stateId"
        value="id"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('filters.status')"
        :fetchData="fetchCitiesPaginated"
        :items="enabled"
        type="enabled"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('filters.orderBy')"
        :fetchData="fetchCitiesPaginated"
        :items="orderBy"
        type="orderBy"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterSearch from '@/components/filters/FilterSearch'
import { mapActions, mapGetters } from 'vuex'
import { countriesList } from '../../util/enums'

export default {
  name: "CityListFilters",
  components: { FilterAutocomplete, FilterSearch },
  data() {
    return {
      selectedCity: null,
      selectedCountry: null,
      orderBy: [
        { value: 'ASC', name: 'A-Z' },
        { value: 'DESC', name: 'Z-A' },
      ],
      enabled: [
        { value: true, name: 'Ativa' },
        { value: false, name: 'Desabilitada' },
      ],
      countries: countriesList.map((country) => {
        return {
          text: `${country.flag} ${country.country}`,
          value: country.value
        }
      }),
    }
  },
  watch: {
    filters(val) {
      if (val.countryCode) {
        this.selectedCountry = val.countryCode
        this.fetchStates({ countryCode: this.selectedCountry })
      } else {
        this.selectedCountry = null
        if (val.stateId) {
          val.stateId = null
        }
      }

    },
  },
  computed: {
    ...mapGetters(['cities', 'states', 'filters'])
  },
  methods: {
    ...mapActions(['fetchStates', 'fetchCitiesPaginated'])
  }
}
</script>
